// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $('.js-menu-mobile').click(function () {
            $('.menu-mobile').fadeIn();
        });
        $('.js-close').click(function () {
            $('.menu-mobile').fadeOut();
        });

        if($('a[data-fancybox]').length) {
            $('a[data-fancybox]').fancybox();
        }

    });

    window.addEventListener('scroll', function() {
        const targetElement = document.getElementById('sodo'); // Thay 'your-element-id' bằng ID của phần tử bạn muốn theo dõi
        
        if (!targetElement) {
            return; // Dừng lại nếu không tìm thấy phần tử
        }
        
        const previewElement = document.querySelector('.singleProd__seatFixed');

        const elementRect = targetElement.getBoundingClientRect(); // Lấy kích thước và vị trí của phần tử

        // Điều kiện: Khi đáy của phần tử VƯỢT QUA khỏi khung nhìn (viewport)
        // Hoặc, khi toàn bộ phần tử đã nằm trên khung nhìn (nghĩa là bạn đã cuộn qua nó)
        if (elementRect.bottom < 0) {
            if(previewElement) {
                previewElement.classList.remove('d-none');
                previewElement.classList.add('d-block');
            }
            // --- THỰC HIỆN HÀNH ĐỘNG CỦA BẠN TẠI ĐÂY ---
            console.log('Bạn đã cuộn qua hết phần tử!');

            // Ví dụ hành động: Thêm một class mới, thay đổi nội dung, v.v.
            // targetElement.classList.add('scrolled-past');

            // Quan trọng: Nếu bạn chỉ muốn hành động này xảy ra MỘT LẦN, hãy hủy bỏ lắng nghe sự kiện
            // window.removeEventListener('scroll', arguments.callee); // Lưu ý: arguments.callee không được khuyến khích trong strict mode
            // Hoặc tốt hơn là dùng cờ (flag) như ví dụ dưới đây
        }else {
            if(previewElement) {
                previewElement.classList.remove('d-block');
                previewElement.classList.add('d-none');
            }
        }
    });

    window.addEventListener('load', () => {
        const marqueeContainer = document.getElementById('myMarquee');
        if (!marqueeContainer) {
            console.error("Marquee container '#myMarquee' not found.");
            return;
        }

        const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
        if (!marqueeWrapper) {
            console.error("Marquee wrapper '.marqueeContainer' not found inside '#myMarquee'.");
            return;
        }

        const originalItems = Array.from(marqueeWrapper.children);
        if (originalItems.length === 0) {
            console.warn("Marquee wrapper has no child elements.");
            return; // No items to animate
        }

        // --- Configuration ---
        const speed = 80; // pixels per second
        const direction = -1; // -1: Left, 1: Right (Current logic best supports -1)
        let pauseOnHover = true;

        // --- Clone items ---
        // Clear existing clones if the script runs again (e.g., in development)
        while (marqueeWrapper.children.length > originalItems.length) {
            marqueeWrapper.removeChild(marqueeWrapper.lastChild);
        }
        // Clone
        originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            // Optional: Add a class or attribute to identify clones for debugging
            // clone.setAttribute('data-clone', 'true');
            marqueeWrapper.appendChild(clone);
        });

        // --- Calculate width and duration based on actual rendered width ---
        // Ensure styles are applied and layout is calculated
        // requestAnimationFrame can help ensure layout is stable before measuring
        requestAnimationFrame(() => {
            // Measure the total width of the wrapper containing original + clones
            const totalWidth = marqueeWrapper.scrollWidth;

            // The width needed for one cycle is half of the total width
            const resetWidth = totalWidth / 2;

            // If calculated width is zero or container is not wide enough for scrolling, stop.
            if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                // console.warn("Marquee content is not wide enough to scroll or width calculation failed.");
                // Optionally remove clones if not scrolling
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
                return;
            }

            // Calculate duration
            const duration = (speed > 0) ? (resetWidth / speed) * 1000 : 0; // in ms

            // Cancel any previous animation on the wrapper
            if (marqueeWrapper.animation) {
                marqueeWrapper.animation.cancel();
            }

            // --- Create Animation using WAAPI ---
            if (duration > 0) {
                const animation = marqueeWrapper.animate(
                    [
                        { transform: `translateX(25px)` },
                        { transform: `translateX(${direction * resetWidth}px)` }
                    ],
                    {
                        duration: duration,
                        iterations: Infinity,
                        easing: 'linear'
                    }
                );

                // Store the animation object
                marqueeWrapper.animation = animation;

                // --- Handle Pause/Play on Hover ---
                if (pauseOnHover) {
                    // Use variables to store bound functions for easy removal later if needed
                    const pauseAnimation = () => marqueeWrapper.animation?.pause();
                    const playAnimation = () => marqueeWrapper.animation?.play();

                    marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                    marqueeContainer.addEventListener('mouseleave', playAnimation);

                    // Optional: Store listeners for potential cleanup
                    marqueeContainer.animationListeners = { pauseAnimation, playAnimation };
                }
            } else {
                // If duration is 0, ensure clones are removed if they were added
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
            }
        }); // End of requestAnimationFrame

    });

})(jQuery)